module.exports = __webpack_public_path__ + "static/media/elements@2x.3d42e263.png";